import {Page} from "@/libwyze-shared/types";
import React, {ReactElement} from "react";
import {Typography} from "@mui/material";
import {StyledBoxColumn, StyledBoxRow, StyledSpan} from "@/shared/StyledComponents";
import {CheckinType} from "@/checkin-common/types";
import {CheckinScreenType, CheckinState, LookupType} from "./CheckinPlayerPreviewFragment";
import {PersonAddAltOutlined, PersonOutlined} from "@mui/icons-material";
import {ChooseCard} from "./components/ChooseCard";

export function PatientTypeScreen(props: {
  practicePage: Page,
  pushScreenType: (st: CheckinScreenType) => void,
  checkinState: CheckinState,
  setCheckinState: (checkin: CheckinState) => void,
}): ReactElement {
  return <>
    <StyledBoxColumn style={{alignItems: "flex-start", gap: 0}}>
      <Typography variant={"h2"} style={{fontWeight: 900}}>
        Have you been here before?
      </Typography>
      <Typography style={{fontSize: "100%", opacity: 0.5}}>
        This helps us find or create your record.
      </Typography>
    </StyledBoxColumn>
    <StyledBoxRow style={{width: "100%", gap: 16}}>
      <ChooseCard
        icon={<PersonOutlined/>}
        title="I've been here before"
        description="We'll look you up by your phone number."
        onClick={() => {
          props.setCheckinState({...props.checkinState, lookupType: LookupType.PROFILE});
          props.pushScreenType(CheckinScreenType.ENTER_PHONE_NUMBER);
        }}
      />
      <ChooseCard
        icon={<PersonAddAltOutlined/>}
        title="I'm a new patient"
        description="Register and complete your details. Takes only a few minutes."
        onClick={() => {
          props.setCheckinState({...props.checkinState, type: CheckinType.REGISTER});
          props.pushScreenType(CheckinScreenType.REGISTER_FORM);
        }}
      />
    </StyledBoxRow>
    <StyledSpan/>
  </>;
}
